import { useState } from 'react'

import { Checkbox } from '../../components'
import { DataFarmingTable } from './data-farming-table'

export function DataFarming() {
    const [agree, setAgree] = useState(false)
    const [agreed, setAgreed] = useState(
        localStorage.getItem('data-farming-agreement'),
    )

    const handleAgree = () => {
        localStorage.setItem('data-farming-agreement', 'true')
        setAgreed('true')
    }

    if (agreed) return <DataFarmingTable />
    return (
        <div>
            <h1 className='mt-16'>Data Farming</h1>
            <p className='my-8 leading-loose text-black text-base font-light w-2/5'>
                Connect your accounts to create your DeFi credit score, we
                encrypt your sensitive data so that it can only be accessed by
                you and our team of data scientists (with your permission) — we
                never share or sell your data — you are giving us permission to
                train credit models only! Once shared, your data is used to
                train our machine learning models while building your
                personalized DeFi credit score, helping the Masa Protocol offer
                tailor-made loan products for you and other users. At all times,
                your data is encrypted, and we don’t use it to self-identify you
                or market to you — ever. If you want us to stop using your data
                for training models, you can opt out and stop earning rewards.
            </p>
            <Checkbox
                value={agree}
                onChange={e => setAgree(e.target.checked)}
                label='Agree to terms and conditions'
            />
            <button
                className='my-16 h-16 py-2 px-5 mr-3 rounded-sm bg-black text-white w-1/6'
                type='button'
                onClick={handleAgree}>
                Start Farming Data
            </button>
        </div>
    )
}
